import React  from 'react';
import Popup from 'reactjs-popup';
import 'reactjs-popup/dist/index.css';
import './App.css';
import './Notebook.css';
import './NotebookDotsPopup.css';
import NotebookLang from './NotebookLang.json';
import { AiOutlineEdit, AiOutlineDelete } from "react-icons/ai";

class NotebookDotsPopup extends React.Component {

	constructor(props) {

		super(props);

		this.state = {
		}
	}
		
	onPopUpClosed() {
		this.props.setNotebookDotsPopupYN(false);
	}

	async onClickEdit() {
		this.props.setNotebookEditPopupYN(true);
		this.onPopUpClosed();
	}
	
	async onClickDelete() {
		this.props.setNotebookDeletePopupYN(true);
		this.onPopUpClosed();
	}
	
	renderContent() {

		return (
			<div className="NotebookDotsPopupTopContainer">
				<div style={{height: "10px"}}></div>
				<div
				  role="menuitem"
				  className="NotebookDotsPopupLink"
				  onClick={() => this.onClickEdit()}
				>
					<div className="NotebookDotsPopupLinkColumn1">
						<AiOutlineEdit style={{ color: "black", width: "25px", height: "25px" }} />
					</div>
					<div className="NotebookDotsPopupLinkColumn2">{this.props.getLang(NotebookLang, "editTitle")}</div>				  					  
				</div>
				<div
				  role="menuitem"
				  className="NotebookDotsPopupLink"
				  onClick={() => this.onClickDelete()}
				>
					<div className="NotebookDotsPopupLinkColumn1">
						<AiOutlineDelete style={{ color: "black", width: "25px", height: "25px" }} />
					</div>
					<div className="NotebookDotsPopupLinkColumn2">{this.props.getLang(NotebookLang, "deleteNotebook")}</div>				  					  
				</div>
				<div style={{height: "10px"}}></div>
			</div>
		);
	}
	
	render() {
		
		var renderPopupYN = this.props.renderPopupYN;
		
		if (!renderPopupYN) {
			return null;
		}

		var positionX = this.props.positionX;
		var positionY = this.props.positionY;

		return (
			<Popup
				className="notebook-dots-popup"
				open={true}
				closeOnEscape
				closeOnDocumentClick
				contentStyle={{
					position: 'fixed',
					top: positionY,
					left: positionX,
				}}
				overlayStyle={{ background: 'rgba(0, 0, 0, 0)' }}
				onClose={() => this.onPopUpClosed()}
			>
				{this.renderContent()}
			</Popup>
		);
	}
}

export default NotebookDotsPopup;


